<div *ngIf="loading" class="wrapper" fxFlex fxLayout="column" fxLayoutAlign="center center">

    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>

    <p>{{ message }}</p>
</div>
